import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagCodigoBarraFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagCodigoBarra'>
      {({ field }) => (
        <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagCodigoBarra' label='Uso de código de barras' />
      )}
    </Field>
  )
}

export default React.memo(FlagCodigoBarraFormGroup)
